import { render, staticRenderFns } from "./ZyroRadio.vue?vue&type=template&id=fa4950ba&scoped=true&"
import script from "./ZyroRadio.vue?vue&type=script&lang=js&"
export * from "./ZyroRadio.vue?vue&type=script&lang=js&"
import style0 from "./ZyroRadio.vue?vue&type=style&index=0&id=fa4950ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4950ba",
  null
  
)

export default component.exports